<template>
    <div style="position: relative;left: 0;top: 0;bottom: 0;right: 0;width:100%;">
        <div class="left-head">
            <el-row>
                <el-col :span="24">用户信息</el-col>
            </el-row>
        </div>
        <div class="left">
            <div class="left-flex">
                <el-row>
                    <el-col :span="6" class="userInfo">
                        用户名称：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerName"></span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="userInfo">
                        用户编号：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerCode"></span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="userInfo">
                        用户地址：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerAddr"></span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="userInfo">
                        联系人：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerContactPerson"></span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="userInfo">
                        手机号码：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerMobile"></span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="userInfo">
                        电子邮箱：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerEmail"></span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="right-head">
            <el-row>
                <el-col :span="24">{{titleName}}

                    <el-button @click="change" size="small" style="float: right;color:#009bac;font-weight: bold;"
                               :disabled="loading">
                        <svg-icon icon-class="切换" style="height: 1rem;"></svg-icon>&nbsp;{{name}}
                    </el-button>


                    <!--style="width: 16vw;margin-right: 10px;float: right;"-->
                    <el-date-picker
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            style="width: 16vw;margin-right: 1rem;float: right;"
                            v-model="date"
                            @change="changeTime"
                            time-arrow-control
                            align="left"
                            :disabled="loading"
                    >
                        <!--
                            :picker-options="pickerOptions"-->
                    </el-date-picker>
                    <!--<el-radio-group v-model="dateUnit" size="mini"
                                    @change="changeDateUnit" style="float: right;margin-right: 10px;"
                                    :disabled="disabled">-->
                    <el-radio-group v-model="dateUnit" size="mini"
                                    @change="changeDateUnit" style="float: right;margin-right: 1rem;"
                                    :disabled="loading">
                        <el-radio-button label="day">日</el-radio-button>
                        <el-radio-button label="week">周</el-radio-button>
                        <el-radio-button label="month">月</el-radio-button>
                        <el-radio-button label="year">年</el-radio-button>
                    </el-radio-group>


                    <!--<el-button size="mini" type="primary" @click="echarts('day')">查询</el-button>-->


                </el-col>
            </el-row>
        </div>
        <div class="right">

            <div class="right-content">
                <div class="content-table" v-show="showType" v-loading="loading">

                    <el-table
                            :data="tableData"
                            stripe
                            size="small"

                            height="100%" width="100%"
                    >
                        <!-- height="calc(70vh - 205px)" width="100%"-->
                        <!--<el-table-column v-for="(item,index) in tableColumn" :label="item.name"
                                        :prop="item.prop" v-if="item.show" :key="index" align="center" :render-header="labelHead"></el-table-column>-->
                        <!--:row-style="cellHeight"
                              style="width: 100%"
                            row-style="height:0"
                            cell-style="padding:0"-->
                        <!-- <el-table-column
                                 type="selection">

                         </el-table-column>-->
                        <el-table-column
                                label="序号"
                                width="50%"
                        >
                            <template slot-scope="scope">
                                <span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="time"
                                label="时间"
                                :formatter="tableTimeFormat">

                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="customerName"
                                label="用户名称"
                                :formatter="tableStringFormat">
                        </el-table-column>

                        <el-table-column
                                align="center"
                                prop="meterId.name"
                                :formatter="tableStringFormat"
                                label="仪表名称">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterId.code"
                                :formatter="tableStringFormat"
                                label="仪表编号">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterId.meterNum"
                                :formatter="tableStringFormat"
                                label="表号">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterId.energyType"
                                :formatter="tableStringFormat"
                                label="能耗类型"
                        >
                        </el-table-column>
                        <!--<el-table-column
                                align="center"
                                prop="meterTypeName"
                                label="仪表类型">
                        </el-table-column>-->
                        <el-table-column
                                align="center"
                                prop="timeEnergyData.energyValue"
                                :formatter="tableStringToFixed"
                                label="能耗量(kWh/m³)">
                        </el-table-column>

                        <el-table-column
                                align="center"
                                prop="timeMoneyData.energyValue"
                                :formatter="tableStringToFixed"
                                label="能耗费用(元)">
                        </el-table-column>

                    </el-table>

                    <div class="energy-data-query-pagination">


                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 30, 50, 100]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="pageTotal" style="width:100%"
                                align="center"
                                :disabled="loading">
                        </el-pagination>


                    </div>
                </div>
                <div v-show="!showType">
                    <el-col>
                        <el-radio-group v-model="tabPosition" size="mini" style="float: right;padding-right: 1rem;margin-top: 1rem"
                                        :disabled="loading">
                            <el-radio-button label="1">能耗量</el-radio-button>
                            <el-radio-button label="0">能耗费用</el-radio-button>
                        </el-radio-group>
                    </el-col>
                </div>
                <div v-show="!showType" id="myChart"
                     style="width: 59.5vw;height: 45vh;" v-loading="loading"></div>
            </div>
        </div>
    </div>
</template>

<script>
  import {queryCustomerById} from '@/api/customerUser'
  import {selectCustomerUserMeter} from '@/api/CustomerUserMeter'
  import {tree, expandedCustomerWithMeter} from '@/utils/energyUtilTree'
  import {getEnergyItem} from '@/api/EnergyItem'
  import {exportExcel} from '@/utils/excelUtil'
  import {option} from '@/utils/echartsUtile'
  import {getCustomerEnergy} from '@/api/customerEnergy'
  import {mapGetters} from 'vuex'
  import Flex from "../../../components/Flex"
  import {getStartAndEnd, formatToHour, formatToDay, formatToMonth, formatDate, format} from '@/utils/time'
  import echarts from 'echarts'
  import {energyUnitEnergyData} from '@/api/EnergyUnit'
  import {
    formartData,
    formartDataById,
    addTitle,
    formartTitle,
    formatDataByType,
    concatAllData,
    selectMeters
  } from '@/utils/energyData'

  export default {
    name: "energyDataQuery",
    components: {
      'flex': Flex
    },
    computed: {
      ...mapGetters([
        'screenWidth',
        'fontSize'
      ])
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      },
      screenWidth() {
        if (!this.timer) {
          this.timer = true
          setTimeout(() => {
            this.myChart.resize()
            this.timer = false
          }, 10)
        }
      },
      meterType() { // 监听能源类型变化
        this.finallyData = []
        this.tableData = []
        this.selectEnergyUnit().then(response => {
          /*console.log('response')
          console.log(response)*/
          /*默认展开和获取第一位业主用户的所有表信息*/
          this.expandedCustomerWithMeter(response).then(() => {
            this.energyUnitEnergyData()
          })
        })
      },
      tabPosition() {
        this.loading = true
        if (this.tabPosition === '0') {
          this.drawECharts(this.energyMoneySet)
        }

        else {
          this.drawECharts(this.energyDataSet)
        }
      }
    },
    data() {
      return {
        titleName: '能耗记录',
        colorList: ['#009BAC', '#F8AD34', '#F1511B', '#E88678', '#4774BF'],
        loading: false,
        showType: true,
        name: '能耗趋势',
        data: [],
        labelWidth: 'calc(10vw - 1px)',
        tableData: [],
        currentPage: 1,
        pageTotal: 1,
        pageSize: 10,
        energyMoneySet: [],
        energyDataSet: [],
        finallyData: [],
        energyMoney: [],
        energyData: [],
        condition: {
          /*查询条件*/
          dateUnit: 'day',
          startDate: '',
          endDate: '',
          customerId: this.$store.getters.customerId,
          energyUnitIds: '', /*9eb9741ef1664760a374d75032ebbb8f,605670038d5d4e57b4312c0d45ccbdf9*/
          energyItemIds: ''/*16396ef1-06a1-4896-a3d6-6c3eb17df360,11d11b4d-d0d6-4953-9273-648b0c800992*/
        },
        meters: [],
        dateUnit: 'month',
        date: [],
        tabPosition: '1',
        customerName: "",
        customerCode: "",
        customerMobile: "",
        customerAddr: "",
        customerEmail: "",
        customerContactPerson: "",
        customerId: this.$store.getters.customerId,
        customerUserId: this.$store.getters.userId,
        selected :[]
      }
    },
    mounted() {
      this.loading = true
      /*this.myChart = echarts.init(document.getElementById('myChart'))*/
      this.queryUserInfo() //查询用户信息
      this.getCustomerEnergy(this.$store.getters.customerId).then(() => {/*查询客户能耗分项*/
        /*初始化ECharts*/
        this.myChart = echarts.init(document.getElementById('myChart'))
        this.myChart.on('legendselectchanged', (obj) => {
          this.selected = obj.selected
        })
        /*查询用户仪表*/
        /*this.customerUserId = '0d81bf904cac40e693749f9cbecfc708'*/
        this.selectCustomerUserMeter(this.customerUserId).then(() => {
          if (this.meters === '' || this.meters === null || this.meters === undefined) {
            this.loading = false
            this.$message({
              type: 'warning',
              message: '用户尚未配表'
            })
          }

          else this.echarts('initialize')
        })
        /*默认展开和获取第一位业主用户的所有表信息*/
        /*this.expandedCustomerWithMeter(response).then(() => {
          this.echarts('initialize')
        })*/

      })
    },
    methods: {
      change() {
        this.showType = !this.showType
        if (this.showType) {
          this.titleName = '能耗记录'
          this.name = '能耗趋势'
        }

        else {
          this.titleName = '能耗趋势'
          this.name = '能耗记录'
        }
      },
      echarts(val) { /* 根据查询数据绘制echarts图表*/
        if (val === 'initialize') {
          this.changeDateUnit('month')
        } else {
          if (this.date.length === 0) {
            const h = this.$createElement
            this.$message.error({
              message: h('p', null, [
                h('span', {style: 'color: teal'}, '未选查询时间!  '),
                h('i', {style: 'color: red'}, ' 请选择查询时间段!')
              ])
            })
            return
          }
          this.condition.dateUnit = 'day'
          this.dateUnit = null
          this.energyUnitEnergyData()
        }
      },
      handleSizeChange: function (size) {
        this.pageSize = size
        this.tableData = this.searchByPage(this.finallyData)
      },
      handleCurrentChange: function (currentPage) {
        this.currentPage = currentPage
        this.tableData = this.searchByPage(this.finallyData)
      },
      searchByPage(data) {
        if (data === null || data === undefined) return
        /* 数据总个数dataTotal, pageTotal总页数, 每页个数pagesize, 当前页数currentPage*/
        const dataTotal = data.length
        this.pageTotal = dataTotal
        /* dataTotal / pageSize + ((dataTotal % pageSize) > 0 ? 1 : 0);*/
        const start = ((this.currentPage - 1) * this.pageSize)
        const end = this.currentPage * this.pageSize
        return data.slice(start, end)
      },
      changeTime(time) {
        if (time[0].getTime() === time[1].getTime()) {
          this.condition.startDate = time[0]
          time[1].setHours('23')
          time[1].setMinutes('59')
          time[1].setSeconds('59')
          this.condition.endDate = time[1]
          this.condition.dateUnit = 'hour'
          this.dateUnit = 'oneDay'
          this.energyUnitEnergyData()
          return
        }
        this.condition.startDate = time[0]
        this.condition.endDate = time[1]
        this.echarts('day')
      }, changeDateUnit(val) { /* 日周月年查询*/
     /*   console.log('表')
        console.log(this.meters)*/
        if (this.meters !== [] && this.meters !== null && this.meters !== undefined && this.meters.length !== 0) {
          this.currentPage = 1
          this.pageTotal = 1
          this.date = []
          if (val === 'day') {
            this.condition.dateUnit = 'hour'
            const startAndEnd = getStartAndEnd('now', 'day')
            this.condition.startDate = startAndEnd.start
            this.condition.endDate = startAndEnd.end
          }
          if (val === 'week') {
            this.condition.dateUnit = 'day'
            const startAndEnd = getStartAndEnd('now', 'week')
            this.condition.startDate = startAndEnd.start
            this.condition.endDate = startAndEnd.end
          }
          if (val === 'month') {
            this.condition.dateUnit = 'day'
            const startAndEnd = getStartAndEnd('now', 'month')
            this.condition.startDate = startAndEnd.start
            this.condition.endDate = startAndEnd.end
          }
          if (val === 'year') {
            this.condition.dateUnit = 'month'
            const startAndEnd = getStartAndEnd('now', 'year')
            this.condition.startDate = startAndEnd.start
            this.condition.endDate = startAndEnd.end
          }
          this.energyUnitEnergyData()
        } else {
          this.loading = false
          this.$message({
            type: 'warning',
            message: '用户尚未配表'
          })
        }


      }, tableTimeFormat(row, column, cellValue) { // 表格中时间格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return format(cellValue, 'YYYY-MM-DD HH:mm:ss')
        }
        return '--'
      },
      tableStringToFixed(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          let rs = cellValue.toString().indexOf('.');
          if (rs < 0) {
            cellValue += '.00';
          }
          else{
            cellValue = cellValue.toFixed(2)
          }
          return cellValue;
        }
        return '--'
      },
      tableStringFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue
        }
        return '--'
      },
      energyUnitEnergyData() { /* 查询数据 包括能耗量和能耗费用*/
        this.loading = true
        if (this.condition.energyItemIds === '') return
        this.option = option()
        this.data = []
        this.tableData = []
        this.currentPage = 1
        this.pageTotal = 1
        this.energyMoneySet = []
        this.energyDataSet = []
        this.finallyData = []
        this.energyMoney = []
        this.energyData = []

        /*this.condition.energyUnitIds = '9eb9741ef1664760a374d75032ebbb8f,605670038d5d4e57b4312c0d45ccbdf9,67d383bc251e4d7e99d4b3afcac19c6e'
        */
      /*  console.log('查询条件')
        console.log(this.condition)*/
        energyUnitEnergyData(this.condition).then(response => {/*查询能耗量*/
          if (response.code === 200 && response.infoJson.data !== null && response.infoJson.data.length !== 0) {
            /*能耗量原始信息*/
           /* console.log('能耗量原始信息')
            console.log(response.infoJson)*/

            /*根据能耗量和能耗费用分类*/
            const typeArray = formatDataByType(response.infoJson.data)
           /* console.log('根据能耗量和能耗费用分类')
            console.log(typeArray)*/

            let money = typeArray.money
            /*能耗费用*/
            let energy = typeArray.energy
            /*能耗量*/
            const xAix = response.infoJson.xAix
            const xAixIndex = response.infoJson.xAixIndex
            /*console.log('根据id分类')*/
            const moneyArray = formartDataById(money, this.meters, xAix)
            /*根据id分类*/
            const energyArray = formartDataById(energy, this.meters, xAix)
            /*根据id分类*/




            /*根据时间戳筛选后的信息*/
            for (const i in moneyArray) {
              const d = formartData(moneyArray[i], xAix, xAixIndex)
              this.energyMoneySet.push(d)
              this.energyMoney = this.energyMoney.concat(d)
              /**/
            }
            for (const i in energyArray) {
              const d = formartData(energyArray[i], xAix, xAixIndex)
              this.energyDataSet.push(d)
              this.energyData = this.energyData.concat(d)

              /**/
            }
           /* console.log('*')
            console.log(this.energyMoney)
            console.log(this.energyData)*/
            /*const energyType = this.meterType + '' === '2' ? '电' : '水'*/
            /*最终数据*/
            this.finallyData = concatAllData(this.energyMoney, this.energyData, this.meters, xAix, this.customerName)
           /* console.log('最终数据')
            console.log(this.finallyData)*/

            /*传递能耗量筛选后的信息*/


            /*console.log('echarts数据')*/
            /*添加表名*/
            if (this.tabPosition === '0') {
              this.drawECharts(this.energyMoneySet)
            }

            else {
              this.drawECharts(this.energyDataSet)
            }
          } else {

            /*console.log(response.infoJson.xAix)
            this.myChart.resize()
            this.option = option()
            this.option.xAxis[0].data = response.infoJson.xAix
            this.myChart.setOption(this.option, true)*/
            let temp = response.infoJson.xAix

            for (let i in temp) {
              temp[i] = {time: temp[i]}

            }
            let tempSet = []
            console.log(this.meters)
            for (let j in this.meters) {
              temp.name = this.meters[j].name
              tempSet[j] = Object.assign([], temp);
            }

            console.log(tempSet)


            /* let tempSet = []
             for (let i in temp)
             {
               tempSet.push({time : temp[i]})

             }*/
            this.energyMoneySet = tempSet
            this.energyDataSet = tempSet
            if (this.tabPosition === '0') {
              this.drawECharts(this.energyMoneySet)
            }

            else {
              this.drawECharts(this.energyDataSet)
            }
          }


        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '能耗量查询失败'
          })
          console.log(error)
        })

      }, drawECharts(set) {/*获取分组后的数据,显示echarts*/

      /*  console.log('set')
        console.log(set)*/
        this.option = option()
        this.option.legend.top = '0%'
        this.option.legend.left = '20%'
        this.option.legend.right = '20%'
        this.option.legend.selected = this.selected
        this.option.tooltip.position = (point, params, dom, rect, size) => {/*提示框位置计算*/
          //其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
          let x = point[0];//
          let y = point[1];
          let viewWidth = size.viewSize[0];
          let viewHeight = size.viewSize[1];
          let boxWidth = size.contentSize[0];
          let boxHeight = size.contentSize[1];
          let posX = 0;//x坐标位置
          let posY = 0;//y坐标位置

          if (x < boxWidth) {//左边放不开
            posX = 5;
          } else {//左边放的下
            posX = x - boxWidth;
          }

          if (y < boxHeight) {//上边放不开
            posY = 5;
          } else {//上边放得下
            posY = y - boxHeight;
          }

          return [posX, posY];
        }
        this.option.grid = {
          top: '30rem',
          left: '6.5%',
          right: '1%',
          bottom: '11%',
          containLabel: false
        }
        if (this.tabPosition === '1') {

          this.option.yAxis = [
            {
              type: 'value',
              name: '',
              axisLabel: {
                textStyle: {
                  color: '#999',//坐标值得具体的颜色

                },
                formatter: function (value, index) { // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                  if (value >= 1000 && value < 1000000) {
                    value = value / 1000 + "K";
                  } else if (value >= 1000000 && value < 1000000000) {
                    value = value / 1000000 + "M";
                  } else if (value >= 1000000000) {
                    value = value / 1000000000 + "B";
                  } else if (value <= -1000 && value > -1000000) {
                    value = value / 1000 + "K";
                  } else if (value <= -1000000 && value > -1000000000) {
                    value = value / 1000000 + "M";
                  } else if (value <= -1000000000) {
                    value = value / 1000000000 + "B";
                  }
                  return value
                }
              }, axisLine: {
                lineStyle: {
                  type: 'solid',
                  color: '#999'//左边线的颜色
                }
              },
            }
          ]
          this.option.yAxis[0].name = '能耗量 / kWh/m³'
        }

        else {
          this.option.yAxis = [
            {

              type: 'value',
              name: '',
              axisLabel: {
                formatter: function (value, index) { // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                  if (value >= 1000 && value < 1000000) {
                    value = value / 1000 + "K";
                  } else if (value >= 1000000 && value < 1000000000) {
                    value = value / 1000000 + "M";
                  } else if (value >= 1000000000) {
                    value = value / 1000000000 + "B";
                  } else if (value <= -1000 && value > -1000000) {
                    value = value / 1000 + "K";
                  } else if (value <= -1000000 && value > -1000000000) {
                    value = value / 1000000 + "M";
                  } else if (value <= -1000000000) {
                    value = value / 1000000000 + "B";
                  }
                  return value
                }
              }, axisLine: {
                lineStyle: {
                  type: 'solid',
                  color: '#999'//左边线的颜色
                }
              }/*,
              minInterval: 0.01*//*最小单位*/
            }
          ]
          this.option.yAxis[0].name = '能耗费用(元)'
        }
        for (const j in set) {
          this.option.legend.data[j] = set[j].name
          this.option.series[j] = {
            name: set[j].name,
            type: 'line',
            yAxisIndex: 0,
            smooth: true,
            itemStyle: {
              normal: {
                //好，这里就是重头戏了，定义一个list，然后根据所以取得不同的值，这样就实现了，
                color: this.colorList[j]
              }
            },
            data: []/*,
                  markPoint: {
                    data: [
                      { type: 'max', name: '最大值' },
                      { type: 'min', name: '最小值' }
                    ],
                    symbolSize: [10, 10]
                  }*/
          }
          for (let i = 0; i < set[j].length; i++) {
            if (set[j] === undefined || set[j] === null || set[j].length === 0 || set[j][i].time === undefined || set[j][i].time === null) {
              this.option.xAxis[0].data.push(null)
            }
            /*  else if (this.dateUnit === 'day') {
                if(j == 0) this.option.xAxis[0].data.push(formatToHour(set[j][i].time))
                this.option.legend.data[j] = set[j][i].energyUnitId
                this.option.series[j].name = set[j][i].energyUnitId
              }*/
            if (j == 0) {
              if (this.dateUnit === 'day' || this.dateUnit === 'oneDay') {
                this.option.xAxis[j].data.push(formatToHour(set[j][i].time))
              } else if (this.dateUnit === 'week') {
                /* this.option.xAxis[j].data.push(formatToDay(set[j][i].time) + '号/周' + (i + 1))*/
                this.option.xAxis[j].data.push(formatToDay(set[j][i].time))
              } else if (this.dateUnit === 'month') {
                this.option.xAxis[j].data.push(formatToDay(set[j][i].time))
              } else if (this.dateUnit === 'year') {
                this.option.xAxis[j].data.push(formatToMonth(set[j][i].time))
              } else {
                this.option.xAxis[j].data.push(formatToDay(set[j][i].time))
              }
            }
            /* if(data[i].energyValue > max) max = data[i].energyValue
            max = Math.max(data[i].energyValue, max)*/
            this.option.series[j].data.push(set[j][i].energyValue)
            /* if (set.length > 31) {
              this.option.dataZoom = {
                realtime: true, // 拖动滚动条时是否动态的更新图表数据
                height: 25, // 滚动条高度
                start: 0, // 滚动条开始位置（共100等份）
                end: 30// 结束位置（共100等份）
              }
            } else this.option.dataZoom = {}*/

            /*
                          this.option.series[1].data.push(data[i].energyValue)*/
          }
        }
        /*  max = max + '';
        let i = max.indexOf('.');
        max = Math.pow(10, max.length - i - 1) * (parseInt(max.charAt(0)) + 1)
         this.option.yAxis[0].max = max;
           this.option.yAxis[0].interval = parseInt(this.option.yAxis[0].max / 10)*/
        /* this.option.xAxis[0].axisLabel.interval = (data.length - 31 <= 0 ? 0 : Math.ceil(data.length / 31 - 1))*/
        this.option.toolbox = {}
        this.myChart.resize()
        this.myChart.setOption(this.option, true)
        this.tableData = this.searchByPage(this.finallyData)
     /*   console.log('表格数据')
        console.log(this.finallyData)*/
        this.loading = false

      },
      selectCustomerUserMeter(customerUserId) {

        return new Promise((resolve, reject) => {
          selectCustomerUserMeter(customerUserId).then(response => {
            if (response.code === 200) {
              this.meters = response.infoJson
             /* console.log('meters')
              console.log(this.meters)*/
              for (const i in this.meters) {
                this.condition.energyUnitIds += (this.meters[i].energyId) + ','
              }
              resolve(null)
            }
            else {
              this.loading = false
              reject(response.message)
            }
          }).catch(error => {
            this.loading = false
            reject(error)
          })
        })
      },
      getCustomerEnergy(customerId) {
        return new Promise((resolve, reject) => {
          getCustomerEnergy(customerId).then(response => {
            if (response.code === 200) {
              const customerEnergy = response.infoJson;
            /*  console.log('客户分项ids')
              console.log(customerEnergy)*/
              for (let i in customerEnergy) {
                this.condition.energyItemIds += customerEnergy[i].energyId + ','
              }
              resolve(null)
            }
            else {
              this.loading = false
              reject(response.message)
            }
          }).catch(error => {
            this.loading = false
            reject(error)
          })
        })
      },
      queryUserInfo() { //查询用户信息
        queryCustomerById(this.customerUserId).then(response => {
          let user = response.infoJson
          if (user !== null && user !== undefined) {
            if (user.realName !== null && user.realName !== undefined && user.realName !== "") {
              this.customerName = user.realName
            } else {
              this.customerName = "--"
            }
            if (user.name !== null && user.name !== undefined && user.name !== "") {
              this.customerCode = user.name
            } else {
              this.customerCode = "--"
            }
            if (user.mobile !== null && user.mobile !== undefined && user.mobile !== "") {
              this.customerMobile = user.mobile
            } else {
              this.customerMobile = "--"
            }
            if (user.address !== null && user.address !== undefined && user.address !== "") {
              this.customerAddr = user.address
            } else {
              this.customerAddr = "--"
            }
            if (user.email !== null && user.email !== undefined && user.email !== "") {
              this.customerEmail = user.email
            } else {
              this.customerEmail = "--"
            }
            if (user.contactPerson !== null && user.contactPerson !== undefined && user.contactPerson !== "") {
              this.customerContactPerson = user.contactPerson
            } else {
              this.customerContactPerson = "--"
            }
          } else {
            this.$message({
              type: 'error',
              message: '用户信息查询失败'
            })
          }
        }).catch(error => {

          this.$message({
            type: 'error',
            message: '用户信息查询失败'
          })
        })
      }
    }
  }
</script>

<style scoped>
    .el-col {
        line-height: 40px;
    }

    .el-col-24 {
        font-size: 15px;
        font-weight: 600;
    }

    .left {
        position: absolute;
        left: 0;
        top: 40px;
        bottom: 0;
        width: 26%;
        height: calc(95% - 40px);
        background-color: #ffffff;
        border-radius: 4px;
        overflow: auto;
        /*background-color: #ffffff;
        width: 25% ;
        padding-top: 2rem;
        height: calc(100vh - 12.5rem);*/
    }

    .left-flex {
        display: flex;
        flex-direction: column;
        height: calc(100% - 20px);
        width: calc(100% - 40px);
        margin: 10px 10px 10px 30px;
        font-size: 14px;
    }

    .right {
        position: absolute;
        left: 29%;
        top: 40px;
        bottom: 0;
        width: 71%;
        height: calc(95% - 40px);
        background-color: #ffffff;
        border-radius: 4px;
        overflow: auto;

    }

    .left-head {
        position: absolute;
        left: 0;
        width: 26%;
    }

    .right-head {
        position: absolute;
        left: 29%;
        width: 71%;
    }

    .content-table {
        display: flex;
        align-items: center;
        flex-direction: column;
        height: calc(100vh - 12rem);
        width: 100%;

    }

    .energy-data-query-pagination {
        display: flex;
        width: 100%;
        padding-top: 1rem;
        height: 2rem;
        align-items: center;
        flex-direction: row;
    }

    .userInfo {
        color: #6A6A6A;
        font-size: 14px;
    }

    .userInfoValue {
        font-size: 18px;
        word-break: break-all;
        color: black;
    }

    .right-content {
        /*padding: 1rem 1rem 1rem 1rem;*/
        flex-direction: column;
        display: flex;
        width: calc(100%);
        height: calc(100%);
    }

    .dialogInfo {
        line-height: 20px;
    }
</style>